import React, { Component } from "react";
import "../stylesheets/landingPageStyles.css";
import CourseCard from "../Components/courseCard";
import ReactHlsPlayer from "react-hls-player";
import { faStar, faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import OverviewComponent from "../Components/OverviewComponent";
import WhatYouLearnComponent from "../Components/whatYouLearnComponent";
import BenefitsComponent from "../Components/benefitsComponenet";
import CourseContentComponent from "../Components/courseContentComponent";
import ReviewsComponent from "../Components/reviewsComponent";
import FeedbackComponent from "../Components/feedbackComponent";
import InstructorComponent from "../Components/instructorComponent";
import UpcomingBatchesComponent from "../Shared Components/upcomingBatches";
import TestimonialsModal from "../Components/testimonialsModal";
import axios from "../../axios";
import { axiosWC } from "../../axios";
import Loader from "../../Shared Components/loader";
import FrequentlyAskedQuestionsComponent from "../Components/faq";
import ErrorComponent from "../../Shared Components/404";
import $ from "jquery";
import RegistrationFloaterComponent from "../Components/registrationFloater";
import CrmActions from "../../Shared Components/Crm/crmAction";
import { sendRequestToLogging } from "../../ErrorBoundary";
import ChatAnalyticsComponent from "../Shared Components/chatAnalytics";
import { LineSkeleton } from "../../Skeletons/skeletonTemplates";
import CourseSchemaTag from "../Components/courseSchemaTag.js";
import { gtagHelperFunction } from "../Shared Components/gtagHelperFunction";
import RecommendedCourses from "../../Shared Components/recommendedCourses";
import { withRouter } from "react-router-dom";
import { Rating, Icon, Tab } from "semantic-ui-react";
import Carousel from "react-multi-carousel";
import ContactUs from "../Components/contactUs";
import { setInitiatePayment } from "../utils";
import "react-multi-carousel/lib/styles.css";
// import ConfettiAnimation from "../../Shared Components/confettiAnimation";
import SalesTimer from "../salesTimer";
import { SALE_ACTIVE, SALE_END_DATE, SALE_START_DATE } from "../../urls";
import { getCurrentDate } from "../../utils";
import WhatGFGHaveToOffer from "../Components/whatGfgHaveToOffer";
import CourseLocations from "../Shared Components/locationCard";
import PromotionModal from "../Components/promotionModal";

const fabIconPages = [
  "Data Structures and Algorithms - Self Paced",
  "Data Structures & Algorithms in Python - Self Paced",
  "Data Structures & Algorithms in JavaScript - Self Paced",
  "Master Competitive Programming - Complete Beginner to Advanced",
  "Master C++ Programming - Complete Beginner to Advanced",
  "Master Java Programming - Complete Beginner to Advanced",
];

class LandingPage extends Component {
  constructor(props) {
    super(props);
    var handleToUpdate = this.handleToUpdate.bind(this);
    var handleFillDetailsUpdate = this.handleFillDetailsUpdate.bind(this);
    this.playerRef = React.createRef();
    this.timeLeftRef = React.createRef(null);
    this.testimonialsRef = null;
    this.salesCurrentTimeRef = null;
    this.salesEndTimeRef = null;
    this.currentDateRef = null;
    this.courseTypeRef = null;

    this.state = {
      data: [],
      isVideoModalOpen: false,
      courseOverviewData: undefined,
      learningsData: undefined,
      courseCardData: {},
      regFloaterData: {},
      courseContentData: undefined,
      instructorData: undefined,
      upcomingBatchesData: undefined,
      isLoaded: false,
      selectedBatchData: {},
      registerBatchFlag: false,
      months: [
        "Jan",
        "Feb",
        "March",
        "April",
        "May",
        "June",
        "July",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec",
      ],
      date: new Date(),
      courseSlug: "",
      courseType: "",
      courseRating: "",
      otherBenefits: undefined,
      faq: undefined,
      errorPage: false,
      canEditCourse: false,
      editCourseLink: "",
      hasAnyBatch: true,
      courseImageText: "",
      showCaptureChatBox: false,
      showCapture: false,
      showFeedbacks: false,
      videoLink: "",
      demoVideo: "",
      showMentorRating: null,
      salesData: null,
      urgencyData: null,
      timerData: null,
      salesApiCalled: false,
      recommendedCoursesData: null,
      courseApiCalled: false,
      course_fee_type: null,
      salesTimerData: null,
      testimonials: null,
      showTestimonialModalContent: false,
      salesText: "",
      showSalesText: false,
      currentDate: null,
      activeTab: 0,
      autoRegisterForFree: false,
      activeTabCourseFeature: 0,
      courseFeaturesList: [],
      courseLocations: [],
      activeLocation: null,
      showPromotionModalContent: false,
      addOnsDefaultThumbnail: "",
    };
  }

  setHeaderConfigurations() {
    var prevScrollpos = window.pageYOffset;
    window.onscroll = function () {
      var currentScrollPos = window.pageYOffset;
      if (currentScrollPos >= 600) {
        $("#floater-component").removeClass("hide");
        $("#floater-component").addClass("show");
      }
      if (currentScrollPos < 600) {
        $("#floater-component").removeClass("show");
        $("#floater-component").addClass("hide");
      }
    };
  }

  handleToUpdate(data) {
    var val = {
      isBatchSelected: data.batch_id ? true : false,
      batchID: data.batch_id ? data.batch_id : undefined,
      selectedBatchStartDate: data.start_date
        ? data.start_date.split("T")[0]
        : "",
      showInviteCodeBlock: data.show_invite_code_block,
      batchSlug: data.batch_slug,
      selectedBatchName: data.batch_name,
      warningMessage: data.warning_message,
    };
    this.setState(
      {
        selectedBatchData: val,
        registerBatchFlag: true,
      },
      () => {
        this.props.history.push({
          pathname: `/payments/${this.props.match.params.course_slug}`,
          state: this.state.selectedBatchData,
          search: this.props.location.search,
        });
      }
    );
  }

  handleFillDetailsUpdate(data) {
    var val = {
      isBatchSelected: data.batch_id ? true : false,
      batchID: data.batch_id ? data.batch_id : undefined,
      selectedBatchName: data.batch_name,
      selectedBatchStartDate: data.start_date.split("T")[0],
      batchSlug: data.batch_slug ? data.batch_slug : undefined,
      showInviteCodeBlock: data.show_invite_code_block,
      warningMessage: data.warning_message,
      hasRegistered: true,
    };
    this.setState(
      {
        selectedBatchData: val,
        registerBatchFlag: true,
      },
      () => {
        this.props.history.push({
          pathname: `/payments/${this.props.match.params.course_slug}`,
          state: this.state.selectedBatchData,
          search: this.props.location.search,
        });
      }
    );
  }

  async fetchUserBatchStatus() {
    await axios
      .get(`courses/${this.props.match.params.course_slug}/details/`, {})
      .then((res) => {
        this.setState(
          (prevState) => ({
            courseCardData: {
              ...prevState.courseCardData,
              first_batch: res.data.first_upcoming_batch,
              button_actions: res.data.right_section,
              total_upcoming_batches: res.data.total_upcoming_batches,
            },
            instructorData: {
              all_instructors: res.data.mentors.length ? res.data.mentors : [],
              profile_image: res.data.mentors.length
                ? res.data.mentors[0].profile_image
                : res.data.mentors_icon,
              instructor_name: res.data.mentors.length
                ? res.data.mentors[0].mentor
                : "",
              mentor_description: res.data.mentors.length
                ? res.data.mentors[0].mentor_description
                : "",
              mentor_bio: res.data.mentors.length
                ? res.data.mentors[0].mentor_bio
                : "",
              canEditMentors: res.data.can_add_edit_mentor,
            },
            courseRating: res.data.right_section.ratings.avg_rating,
            canEditCourse: res.data.can_edit_course,
            editCourseLink: res.data.add_edit_course_page_link,
            hasAnyBatch: res.data.has_any_batch,
            currency: res.data.payment_currency_symbol,
            is_logged_in: res.data.is_logged_in,
          }),
          () => {
            // adding record to crm
            let firstUpcomingBatchId = null;

            if (this.state.courseCardData["first_batch"] != undefined)
              firstUpcomingBatchId =
                this.state.courseCardData["first_batch"]["batch_id"];
            this.getKaptureChat();
            if (this.state.is_logged_in) {
              CrmActions.updateUserAction(
                res.data.course_id,
                firstUpcomingBatchId,
                1,
                1
              );
            }
          }
        );
      })
      .catch((err) => {
        sendRequestToLogging(
          JSON.stringify({
            traceback:
              "error = " +
              err +
              " \n URL = " +
              window.location.href +
              "\ntraceback: \n" +
              err.stack,
          })
        );
        if (err.response && err.response.status === 404)
          this.setState({ errorPage: true });
      });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.courseApiCalled !== this.state.courseApiCalled)
      this.startTimerHelper();
    else if (prevState.salesApiCalled !== this.state.salesApiCalled)
      this.startTimerHelper();
  }

  getCurrentDateFromApi = async () => {
    this.setState({
      currentDate: (await getCurrentDate()) || new Date(),
    });
  };

  async componentDidMount() {
    this.getCurrentDateFromApi();
    this.setHeaderConfigurations();
    $("#videoModal").on("hide.bs.modal", () => {
      this.setState({
        isVideoModalOpen: false,
      });
      this.playerRef?.current?.pause();
    });
    let axiosClient = this.props.preview ? axios : axiosWC;
    axiosWC.get(`sale/active`).then((res) => {
      this.setState({
        salesData: res.data,
        salesApiCalled: true,
      });
    });
    await axiosClient
      .get(`courses/${this.props.match.params.course_slug}/`, {})
      .then((res) => {
        document.title = res.data.course_name;
        document.description = res.data.course_overview;
        let recCourseSlug = this.props.match.params.course_slug;

        let lastVisitTime = res?.headers?.["x-date"];
        lastVisitTime = lastVisitTime ? new Date(lastVisitTime) : new Date();
        lastVisitTime =
          lastVisitTime.getFullYear() +
          "-" +
          ("0" + (lastVisitTime.getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + lastVisitTime.getDate()).slice(-2) +
          "T" +
          ("0" + lastVisitTime.getHours()).slice(-2) +
          ":" +
          ("0" + lastVisitTime.getMinutes()).slice(-2) +
          ":" +
          ("0" + lastVisitTime.getSeconds()).slice(-2);

        let currentTime = res?.headers?.["x-date"];
        currentTime = currentTime ? new Date(currentTime) : new Date();
        this.currentDateRef = currentTime;
        let startTime = new Date(res.data.urgency_start_time);
        let endTime = new Date(res.data.urgency_end_time);
        this.salesCurrentTimeRef = currentTime.getTime();
        this.courseTypeRef = res.data.course_type;

        this.setState((prevState) => ({
          regFloaterData: {
            broucher_link: res.data.broucher_link,
          },
        }));

        this.setState({
          courseDetailsApiCalled: true,
          autoRegisterForFree: res?.data?.auto_registration,
          courseFeaturesList: res?.data?.course_feature_list,
          courseLocations: res?.data?.locations,
          addOnsDefaultThumbnail: res?.data?.default_feature_thumbnail,
        });

        if (res.data.urgency_start_time && res.data.urgency_end_time) {
          if (currentTime > startTime && currentTime < endTime) {
            this.setState({
              urgencyData: {
                startTime,
                endTime,
              },
              salesText: "Offer ends in",
            });
            this.salesEndTimeRef = endTime.getTime();
          }
        }
        this.setState((prevState) => ({
          recommendedCoursesData: {
            course_id: res.data.course_id,
            last_visit_time: lastVisitTime,
          },
          courseApiCalled: true,
        }));

        this.setState(
          {
            demoVideo: res.data.demo_video_link,
            showMentorRating: res.data.show_mentor_rating,
            isLoaded: true,
            data: res.data,
            courseType:
              res.data.course_type === 2
                ? "Live Course"
                : res.data.course_type === 1
                ? "Self-Paced Course"
                : "Offline Course",
            courseOverviewData: {
              overviewIcon: res.data.course_overview_icon,
              content: res.data.course_overview,
              course_name: res.data.course_name,
              isIntroVideo: res.data.intro_video_id === null ? false : true,
              intro_video_link: res.data.intro_video_link,
            },
            learningsData: {
              learningsIcon: res.data.what_you_will_learn_icon,
              content: res.data.what_you_will_learn,
            },
            courseCardData: {
              introVideoId: res.data.intro_video_id,
              videoLink: res.data.intro_video_link,
              content: res.data.short_description,
              default_coupon: res.data.warning_message,
              courseType: res.data.course_type,
              course_name: res.data.course_name,
              course_id: res.data.course_id,
              course_fee_type: res.data.course_fee_type,
              total_feedback_rating_count: res.data.total_feedback_rating_count,
              visit_count: res.data.visit_count,
              level: res.data.level,
              course_duration: res.data.course_duration,
              seats_left: res.data.seats_left,
              other_benefits: res.data.other_benefits,
            },
            courseContentData: {
              content: res.data.course_content,
              syllabusPDFLink: res.data.syllabus_pdf,
            },
            otherBenefits: res.data.other_benefits,
            course_slug: res.data.course_slug,
            faq: res.data.faqs,
            courseImageText: res.data.course_image_text,
            showCaptureChatBox: res.data.show_kapture_chat_box,
          },
          () => {
            this.fetchUserBatchStatus();
          }
        );
      })
      .catch((err) => {
        sendRequestToLogging(
          JSON.stringify({
            traceback:
              "error = " +
              err +
              " \n URL = " +
              window.location.href +
              "\ntraceback: \n" +
              err.stack,
          })
        );
        if (err.response && err.response.status === 404)
          this.setState({ errorPage: true });
      });
  }

  activeLocationSetter = (currLocation) => {
    this.setState({
      activeLocation: currLocation,
    });
  };

  startTimerHelper() {
    if (this.state.salesApiCalled && this.state.courseDetailsApiCalled) {
      if (SALE_ACTIVE) {
        let saleStartTime = new Date(SALE_START_DATE).getTime();
        let saleEndTime = new Date(SALE_END_DATE).getTime();
        if (
          !this.salesEndTimeRef &&
          this.salesCurrentTimeRef > saleStartTime &&
          this.salesCurrentTimeRef < saleEndTime
        ) {
          this.salesEndTimeRef = saleEndTime;
          this.setState({
            salesText: "Sale Ends in",
          });
        }
      }

      // this.startTimer();
    }
  }

  // startTimer() {
  //   let timerRef = setInterval(() => {
  //     let distance = this.salesEndTimeRef - this.salesCurrentTimeRef;
  //     let days = Math.floor(distance / (1000 * 60 * 60 * 24));
  //     let hours = Math.floor(
  //       (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  //     );
  //     let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  //     let seconds = Math.floor((distance % (1000 * 60)) / 1000);
  //     if (distance < 0) {
  //       clearInterval(timerRef);
  //       this.setState({
  //         salesTimerData: null,
  //       });
  //     } else {
  //       this.setState({
  //         salesTimerData: {
  //           days,
  //           hours,
  //           minutes,
  //           seconds,
  //         },
  //       });
  //       this.salesCurrentTimeRef = this.salesCurrentTimeRef + 1000;
  //     }
  //   }, 1000);
  // }

  // startTimer() {
  //     let timer = setInterval(() => {
  //         let hours = Math.floor(this.timeLeftRef.current / 3600);
  //         let minutes = Math.floor((this.timeLeftRef.current - (hours * 3600)) / 60);
  //         let seconds = Math.floor(this.timeLeftRef.current % 60);
  //       if (this.timeLeftRef.current < 0) {
  //         clearInterval(timer);
  //         this.setState({
  //             timerData:null
  //         })
  //       } else {
  //         this.setState({
  //             timerData:{
  //                 hours,
  //                 minutes,
  //                 seconds
  //             }
  //         })
  //         this.timeLeftRef.current = this.timeLeftRef.current - 1
  //       }
  //     }, 1000);
  //   };

  salesHandler = () => {
    this.setState({ showSalesText: true });
  };

  handleRegisteredUser(record) {
    CrmActions.updateUserAction(
      this.state.courseCardData.course_id,
      this.state.courseCardData.first_batch.batch_id,
      1,
      1
    );
    this.handleToUpdate(record);
    this.handleFillDetailsUpdate(record);
  }

  handleLocation = (location) => {
    this.setState({
      activeLocation: location,
    });

    var element = document.getElementById("batchSection-parent");
    var headerOffset = 120;
    var elementPosition = element.getBoundingClientRect().top;
    var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };

  discountPercent(normalPrice, discountedPrice) {
    return Math.round(((normalPrice - discountedPrice) / normalPrice) * 100);
  }

  fetchOnlineCourseButton() {
    var record = {
      batch_id: this.state.courseCardData.first_batch.batch_id,
      batch_name: this.state.courseCardData.first_batch.batch_name,
      start_date: this.state.courseCardData.first_batch.reg_start_date,
      batch_slug: this.state.courseCardData.first_batch.batch_slug,
      showInviteCodeBlock:
        this.state.courseCardData.first_batch.show_invite_code_block,
      warning_message: this.state.courseCardData.first_batch.warning_message,
    };

    var data = this.state.courseCardData.button_actions.register_btn;
    var action = this.state.courseCardData.button_actions.register_btn.action;
    var sub_action =
      this.state.courseCardData.button_actions.register_btn.sub_action;
    var button;

    if (action === "user_already_registered_in_batch") {
      if (sub_action === "show_tracks")
        button = (
          <a
            href={
              this.state.courseCardData.button_actions.register_btn.extra
                .batch_url
            }
            className="btn btn-success sofia-pro btn-lg mt-3 w-100"
          >
            Start Course
          </a>
        );
      else if (sub_action === "fee_paid_batch_not_started")
        button = (
          <button disabled className="btn btn-success btn-lg mt-3 w-100">
            Batch not Started
          </button>
        );
      else if (sub_action === "subscribed")
        button = (
          <div>
            <button
              onClick={() => {
                gtagHelperFunction(
                  "click",
                  "course_payfee_bottom",
                  window.location.href
                );
                this.handleRegisteredUser(record);
                setInitiatePayment();
              }}
              className="btn btn-success btn-lg mt-3 w-100 sofia-pro"
            >
              Pay Fee
            </button>
          </div>
        );
      else if (sub_action === "pay_fee")
        button = (
          <div>
            <button
              onClick={() => {
                gtagHelperFunction(
                  "click",
                  "course_payfee_bottom",
                  window.location.href
                );
                this.handleRegisteredUser(record);
                setInitiatePayment();
              }}
              className="btn btn-success btn-lg mt-3 w-100 sofia-pro"
            >
              Pay Fee
            </button>
          </div>
        );
      else if (sub_action === "attend_contest")
        button = (
          <a
            href={data.extra.contest_url}
            className="btn btn-success btn-lg mt-3 w-100 sofia-pro"
          >
            Attend Contest
          </a>
        );
      else if (sub_action === "payment_link_will_open_on")
        button = (
          <button
            disabled
            className="btn btn-success btn-lg mt-3 w-100 sofia-pro"
          >
            Payment Link opens on {data.extra.payment_start_date.split("T")[0]}
          </button>
        );
      else if (sub_action === "payment_link_closed")
        button = (
          <button
            disabled
            className="btn btn-success btn-lg mt-3 w-100 sofia-pro"
          >
            Payment Link Closed
          </button>
        );
      else if (sub_action === "no_seats_available")
        button = (
          <button
            disabled
            className="btn btn-success btn-lg mt-3 w-100 sofia-pro"
          >
            Seats not available
          </button>
        );
      else if (sub_action === "registration_closed")
        button = (
          <button
            disabled
            className="btn btn-success btn-lg mt-3 w-100 sofia-pro"
          >
            Registration Closed
          </button>
        );
    } else if (action === "registration_not_started") {
      button = (
        <button
          disabled
          className="btn btn-success btn-lg mt-3 w-100 sofia-pro"
        >
          Registration not started
        </button>
      );
    } else if (action === "registration_closed") {
      button = (
        <button
          disabled
          className="btn btn-success btn-lg mt-3 w-100 sofia-pro"
        >
          Registration Closed
        </button>
      );
    } else if (action === "registration_open") {
      if (sub_action === "subscribe")
        button = (
          <button
            onClick={() => this.handleToUpdate(record)}
            disabled
            className="btn btn-success btn-lg mt-3 w-100 sofia-pro"
          >
            Subscribe
          </button>
        );
      else if (sub_action === "sign_up_now")
        button = (
          <button
            onClick={() => {
              gtagHelperFunction(
                "click",
                "course_signup_bottom",
                window.location.href
              );
              this.handleToUpdate(record);
            }}
            className="btn btn-success btn-lg mt-3 w-100 sofia-pro"
          >
            Sign-Up Now
          </button>
        );
      else if (sub_action === "login_to_subscribe")
        button = (
          <a
            href={`${window.location.href}?loginMode=${record.batch_id}`}
            className="btn btn-success login-modal-btn btn-lg mt-3 w-100 sofia-pro"
          >
            Login to Subscribe
          </a>
        );
      else if (sub_action === "login_to_register")
        button = (
          <a
            href={`${window.location.href}?loginMode=${record.batch_id}`}
            className="btn btn-success login-modal-btn btn-lg mt-3 w-100 sofia-pro"
            onClick={() =>
              gtagHelperFunction(
                "click",
                "course_loginreg_bottom",
                window.location.href
              )
            }
          >
            Login to Register
          </a>
        );
      else if (sub_action === "registration_closed")
        button = (
          <button
            disabled
            className="btn btn-success btn-lg mt-3 w-100 sofia-pro"
          >
            Registration Closed
          </button>
        );
      else if (sub_action === "free_course")
        button = (
          <button
            onClick={() => {
              gtagHelperFunction(
                "click",
                "course_reg_bottom",
                window.location.href
              );
              this.handleToUpdate(record);
            }}
            className="btn btn-success btn-lg mt-3 w-100 sofia-pro"
          >
            Register Now
          </button>
        );
    }
    return button;
  }

  mapLiveOrOnlineCourseSection() {
    if (this.state.courseCardData.courseType === undefined) {
      return (
        <div id="onlineCourseImage">
          <img
            className="img-fluid d-none d-sm-block mx-auto"
            src="https://media.geeksforgeeks.org/img-practice/Group5339-1618471344.svg"
            alt="Unable to load"
          />
          <img
            className="img-fluid d-sm-none d-block mx-auto"
            src="https://media.geeksforgeeks.org/img-practice/Group5443-1620806697.svg"
            alt="Unable to load"
          />
          <div className="centered col-9">
            <div className="container mt-5 float-left">
              <span className="text-secondary font-weight-bold">
                Collecting your batch status
              </span>
              <div class="jumping-dots-loader">
                <span></span> <span></span> <span></span>{" "}
              </div>
            </div>
          </div>
        </div>
      );
    }
    // for offline and live classes
    if ([0, 2].includes(this.state.courseCardData.courseType)) {
      return (
        <>
          <div className="upcoming-batches">
            <div className="container col-md-11">
              <div className="row mt-5">
                <UpcomingBatchesComponent
                  activeLocationSetter={this.activeLocationSetter}
                  paymentsPageFlag={false}
                  handleUpdate={this.handleToUpdate.bind(this)}
                  handleFillDetailsUpdate={this.handleFillDetailsUpdate.bind(
                    this
                  )}
                  courseType={this.state.courseCardData.courseType}
                  courseSlug={this.props.match.params.course_slug}
                  courseId={this.state.data.course_id}
                  activeLocation={this.state.activeLocation}
                />
              </div>
            </div>
          </div>
        </>
      );
    } else {
      if (
        !this.state.courseCardData.button_actions ||
        this.state.courseCardData.button_actions.action ===
          "checkout_previous_batches"
      )
        return <div></div>;

      return (
        <div className="mb-5">
          {this.state.courseCardData.first_batch.warning_message &&
            this.state.courseCardData.first_batch.warning_message.length >
              0 && (
              <div className="col-12 col-sm-9 mx-auto mb-5 w-100">
                <div className="row mx-auto">
                  <div className="col-12 my-auto">
                    <div className="onlinePremium pl-4 pr-4 pt-2 pb-2 mx-auto">
                      <img
                        className="pr-2"
                        src="https://media.geeksforgeeks.org/img-practice/Group5631-1621599978.png"
                      />
                      <a className="urw-din text-left couponText text-dark">
                        {this.state.courseCardData.first_batch.warning_message}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            )}
          <div id="onlineCourseImage">
            <img
              className="img-fluid d-none d-sm-block mx-auto"
              src="https://media.geeksforgeeks.org/img-practice/Group5339-1618471344.svg"
              alt="Unable to load"
            />
            <img
              className="img-fluid d-sm-none d-block mx-auto"
              src="https://media.geeksforgeeks.org/img-practice/Group5443-1620806697.svg"
              alt="Unable to load"
            />
            <div className="centered col-9">
              {this.state.courseImageText &&
                this.state.courseImageText.length > 0 && (
                  <p className="content-text">{this.state.courseImageText}</p>
                )}
              <p className="text-success font-weight-bold pricingHeader pb-0 mb-0">
                Pricing
              </p>
              <p className="mb-0 price pt-0">
                {this.state.currency}{" "}
                {this.state.courseCardData.first_batch.batch_fee}
              </p>
              {this.state.courseCardData.first_batch.promotional_fee &&
              this.state.courseCardData.first_batch.promotional_fee > 0 ? (
                <div className="mb-1 onlinCourseCardPrice">
                  <span className="h2 text-muted">
                    <s>
                      {this.state.currency}{" "}
                      {this.state.courseCardData.first_batch.promotional_fee}
                    </s>
                  </span>
                  <span className="h5 ml-3 text-success">
                    (
                    {this.discountPercent(
                      this.state.courseCardData.first_batch.promotional_fee,
                      this.state.courseCardData.first_batch.batch_fee
                    )}
                    %)
                  </span>
                </div>
              ) : (
                <div />
              )}
              <div className="col-9 col-sm-5 mx-auto onlineCourseButton">
                {this.fetchOnlineCourseButton()}
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

  async getKaptureChat() {
    if (this.state.showCaptureChatBox) {
      setTimeout(() => {
        this.setState({ showCapture: true });
        setTimeout(function () {
          $("#kapchat-togglebtn").click();
        }, 2000);
      }, 8000);
    }
  }

  playVideo = (videoLink) => {
    this.setState({
      isVideoModalOpen: true,
      videoLink,
    });
  };

  convertToGrouping(data) {
    return String(data).padStart(2, "0");
  }

  showtestimonialModal = () => {
    gtagHelperFunction(
      "clickopen",
      "viewtestimonials_courses",
      window.location.href
    );
    let activeIndex = this.getTabsIndex("Testimonials");
    this.setState({
      showTestimonialModalContent: true,
      activeTab: activeIndex,
    });
  };

  getTabs = () => {
    let tabs = [];
    if (this.state.testimonials)
      tabs.push({
        menuItem: "Testimonials",
        pane: (
          <Tab.Pane>
            {this.state.showTestimonialModalContent && (
              <TestimonialsModal
                courseSlug={this.props.match.params.course_slug}
              ></TestimonialsModal>
            )}
            {!this.state.showTestimonialModalContent && <Loader />}
          </Tab.Pane>
        ),
      });
    if (this.state.courseRating)
      tabs.push({
        menuItem: "Feedbacks",
        pane: (
          <Tab.Pane>
            {this.state.showFeedbacks && (
              <FeedbackComponent
                courseSlug={this.props.match.params.course_slug}
              />
            )}
            {!this.state.showFeedbacks && <Loader />}
          </Tab.Pane>
        ),
      });
    return tabs;
  };

  getTabsIndex = (tab) => {
    return this.getTabs().findIndex((el) => el.menuItem === tab);
  };

  render() {
    if (this.state.errorPage) {
      return <ErrorComponent></ErrorComponent>;
    } else {
      return (
        <React.Fragment>
          {/* Fab Icon */}
          {/* {!this.state.showPromotionModalContent && typeof window !== "undefined" &&
          fabIconPages.includes(this.state.data?.course_name) && 
          (
              <div className="show_fab_icon" onClick={() => {
                if (window.innerWidth <= 768) {
                  window.open("https://play.google.com/store/apps/details?id=free.programming.programming");
                }
                if (window.innerWidth > 768) {
                  this.setState({ showPromotionModalContent: true });
                }
              }}>
                <img
                  src="https://media.geeksforgeeks.org/img-practice/prod/generic/1/Web/Content/Ellipse 7_1689245033.png"
                  alt="Fab Icon"
                />
              </div>
          )}

          {this.state.showPromotionModalContent && 
          <PromotionModal 
            showModal={this.state.showPromotionModalContent} 
            onClose={()=>this.setState({ showPromotionModalContent: false })}
          />} */}

          {this.state.courseCardData.courseType === 0 && <ContactUs />}
          <RecommendedCourses data={this.state.recommendedCoursesData} />
          <CourseSchemaTag data={this.state.data} />
          <section className="backgroundImage">
            {/* <ConfettiAnimation /> */}
            {/* Modal to display video */}

            <div
              class="modal fade"
              id="videoModal"
              data-backdrop="static"
              tabindex="-1"
              aria-labelledby="videoModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="videoModalLabel">
                      {this.state.data?.course_name}
                    </h5>
                  </div>
                  <div class="modal-body">
                    {this.state.isVideoModalOpen && (
                      <ReactHlsPlayer
                        src={this.state.videoLink}
                        autoPlay={true}
                        controls={true}
                        width="100%"
                        height="100%"
                        playerRef={this.playerRef}
                      />
                    )}
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary sofia-pro"
                      data-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Modal to display feedback */}
            <div
              className="modal fade"
              id="feedbackModal"
              data-backdrop="static"
              tabindex="-1"
              aria-labelledby="feedbackModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content feedbackModalCnt">
                  <div className="modal-header header">
                    <div className="modal-title" id="feedbackModalLabel">
                      <p className="sofia-pro title">
                        {this.state.data.course_name}
                      </p>
                      <span className="sofia-pro detailsCnt">
                        <span className="">{this.state.courseType}</span>
                        <span>
                          <span className="divider"></span>
                          <FontAwesomeIcon
                            icon={faStar}
                            className="starIconFeed"
                          />
                          <span>{this.state.courseRating * 1.0}</span>
                        </span>
                      </span>
                    </div>
                    <div
                      className="close closeBtn"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </div>
                  </div>
                  <div className="modal-body body">
                    <Tab
                      panes={this.getTabs()}
                      renderActiveOnly={false}
                      activeIndex={this.state.activeTab}
                      onTabChange={(e, data) => {
                        this.setState({
                          activeTab: data.activeIndex,
                        });
                        let testimonialIndex =
                          this.getTabsIndex("Testimonials");
                        let feedbackIndex = this.getTabsIndex("Feedbacks");

                        if (data.activeIndex === testimonialIndex)
                          this.setState({ showTestimonialModalContent: true });
                        else if (data.activeIndex === feedbackIndex)
                          this.setState({ showFeedbacks: true });
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            {this.state.isLoaded && (
              <RegistrationFloaterComponent
                data={this.state.courseCardData}
                handleUpdate={this.handleToUpdate.bind(this)}
                handleFillDetailsUpdate={this.handleFillDetailsUpdate.bind(
                  this
                )}
                courseSlug={this.props.match.params.course_slug}
                hasBatch={this.state.hasAnyBatch}
                regFloaterData={this.state.regFloaterData}
                isLoggedIn={this.state.is_logged_in}
              />
            )}
            {this.state.canEditCourse && (
              <div className="row ml-0 mr-0 editButton">
                <div className=" col-1">
                  <a
                    type="button"
                    href={this.state.editCourseLink}
                    className="btn btn-light btn-sm rounded-circle"
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </a>
                </div>
              </div>
            )}

            {/* Loading the Navbar Component*/}
            <div className="row ml-0 mr-0">
              <div className="col-11 col-sm-9 col-lg-9 mx-auto mainCard">
                <div>
                  {this.state.data.course_name ? (
                    <p className="font-weight-bold text-left courseNameAdjust mb-0">
                      {this.state.data.course_name}
                    </p>
                  ) : (
                    <div className="col-12 col-md-6">{LineSkeleton(2)}</div>
                  )}
                  <div className="instructorDesc pl-0 pr-0 mb-4 w-100">
                    {/* Commented section was earlier made to display the instructor name on the landing page but has been removed */}
                    {/* {this.state.instructorData.all_instructors.length > 0 ?  
                                        (
                                            <div className = "row w-100 my-auto">
                                                <img className = "col-3 img-fluid rounded-circle profile-image" src = {this.state.instructorData.profile_image}></img>
                                                <div className = "col-9 text-left text-white pl-0 ml-0 pr-0 my-auto"><p className = "mb-0 instructor-header-size"> with <b>{this.state.instructorData.instructor_name}</b><span className = "ml-2 mr-2 v1"></span>{this.state.courseType}
                                                {this.state.courseRating &&
                                                    <span> 
                                                        <span className = "ml-2 mr-2 v1"></span>
                                                        <span data-toggle="modal" data-target="#feedbackModal" className="openFeedModal">
                                                            <img className = "pl-0 pr-0 star-icon" src = "https://media.geeksforgeeks.org/img-practice/Polygon2-1622015238.png"/>
                                                            {parseFloat(this.state.courseRating).toFixed(1)}
                                                        </span>
                                                    </span>
                                                }
                                                </p></div>
                                            </div>
                                        ) :     */}
                    {this.state.courseType && (
                      <p className="d-inline w-100 text-left">
                        <span
                        // className="course_sale_text_class"
                        >
                          {this.state.courseType === "Offline Course"
                            ? "Classroom Based Course"
                            : this.state.courseType}
                        </span>
                        {this.state.courseRating ? (
                          <span>
                            <span className="ml-2 mr-2 v1"></span>
                            <span
                              onClick={() => {
                                gtagHelperFunction(
                                  "clickopen",
                                  "course_ratings",
                                  window.location.href
                                );
                                let activeIndex =
                                  this.getTabsIndex("Feedbacks");
                                this.setState({
                                  showFeedbacks: true,
                                  activeTab: activeIndex,
                                });
                              }}
                              data-toggle="modal"
                              data-target="#feedbackModal"
                              className="openFeedModal"
                            >
                              <Rating
                                icon="star"
                                disabled
                                defaultRating={Math.round(
                                  this.state.courseRating * 1.0
                                )}
                                maxRating={5}
                                id="course-rating"
                              />
                              <Rating
                                icon="star"
                                disabled
                                defaultRating={1}
                                maxRating={1}
                                id="course-rating-mob"
                              />
                              {/* <svg className='mr-2 mb-1' xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 18 18" width="18">
                                                            <rect id="Canvas" fill="#fb8c00" opacity="0" width="18" height="18" /><path fill="#fb8c00" d="M9.2385.2965,11.4,6.0145l6.106.289a.255.255,0,0,1,.15.454l-4.77,3.823,1.612,5.8965a.255.255,0,0,1-.386.2805L9,13.4025l-5.11,3.355a.255.255,0,0,1-.386-.2805l1.612-5.8965L.346,6.7575a.255.255,0,0,1,.15-.454L6.6,6.0145,8.7615.2965a.255.255,0,0,1,.477,0Z" />
                                                        </svg> */}
                              <span
                                // className="course_sale_text_class"
                                style={{
                                  marginLeft: "5px",
                                  textDecoration: "underline",
                                }}
                              >
                                {this.state.courseRating * 1.0}/5 ratings
                              </span>
                              {/* {this.state.courseCardData.total_feedback_rating_count && <span style={{marginLeft:'5px'}}>
                                                            (<span style={{textDecoration:"underline"}}>{this.state.courseCardData.total_feedback_rating_count}</span>)
                                                        </span>} */}
                            </span>
                          </span>
                        ) : (
                          <div></div>
                        )}
                      </p>
                    )}
                    {/* } */}
                  </div>
                </div>
                {this.state.salesText &&
                this.state.courseDetailsApiCalled &&
                this.state.salesApiCalled &&
                this.state.currentDate &&
                this.state.courseCardData.course_fee_type !== 0 ? (
                  <div className="salesTimerContainer">
                    {this.state.showSalesText ? (
                      <p className="salesText">{this.state.salesText}</p>
                    ) : null}
                    <div>
                      {/* <span className="timerValue">{this.convertToGrouping(this.state.salesTimerData.days)}</span>
                                    <span className="timerSeparator">:</span> */}
                      {/* <span className="timerValue">
                        {this.convertToGrouping(
                          this.state.salesTimerData.hours
                        )}
                      </span>
                      <span className="timerSeparator">:</span>
                      <span className="timerValue">
                        {this.convertToGrouping(
                          this.state.salesTimerData.minutes
                        )}
                      </span>
                      <span className="timerSeparator">:</span>
                      <span className="timerValue">
                        {this.convertToGrouping(
                          this.state.salesTimerData.seconds
                        )}
                      </span> */}
                      <SalesTimer
                        urgencyStartTime={this.state?.urgencyData?.startTime}
                        urgencyEndTime={this.state?.urgencyData?.endTime}
                        currentDate={this.state.currentDate}
                        handler={this.salesHandler}
                      />
                    </div>
                  </div>
                ) : null}
              </div>

              {/* Loading the course Card Component */}
              <div className="col-11 col-sm-9 col-lg-9 mx-auto courseCard">
                <CourseCard
                  data={this.state.courseCardData}
                  handleUpdate={this.handleToUpdate.bind(this)}
                  handleFillDetailsUpdate={this.handleFillDetailsUpdate.bind(
                    this
                  )}
                  courseSlug={this.props.match.params.course_slug}
                  hasBatch={this.state.hasAnyBatch}
                  currency={this.state.currency}
                  playVideo={this.playVideo}
                  timerData={this.state.timerData}
                  // salesTimerData={this.state.salesTimerData}
                  urgencyData={this.state.urgencyData}
                  salesText={this.state.salesText}
                  autoRegisterForFree={this.state.autoRegisterForFree}
                  currentDate={this.state.currentDate}
                />
                {this.state.testimonials && (
                  <div className="testimonials-container">
                    <h2 className="font-weight-bold sofia-pro">
                      Students got placed after taking this course at...
                    </h2>

                    <Carousel
                      swipeable
                      draggable={false}
                      showDots
                      responsive={{
                        desktop: {
                          breakpoint: { max: 3000, min: 1101 },
                          items: 3,
                        },
                        tablet: {
                          breakpoint: { max: 1100, min: 769 },
                          items: 2,
                        },
                        mobile: {
                          breakpoint: { max: 768, min: 0 },
                          items: 1,
                        },
                      }}
                      infinite
                      autoPlay
                      keyBoardControl
                      autoPlaySpeed={3000}
                      arrows={false}
                      containerClass="carousel-container"
                      dotListClass="custom-dot-list-style"
                      itemClass="carousel-item-padding-40-px"
                      renderDotsOutside
                    >
                      {this.state.testimonials?.data?.map(
                        (testimonial, index) => (
                          // <div className='testimonials-item'>
                          //     {testimonial.modified_data}
                          // </div>
                          <div
                            className="shadow-sm card mt-3 setReviewCardBorder testimonial-card"
                            key={index}
                            style={{ cursor: "pointer" }}
                            data-toggle="modal"
                            data-target="#feedbackModal"
                            onClick={() => {
                              this.showtestimonialModal();
                            }}
                          >
                            <div className="row pl-3 pr-0 pt-2">
                              <div className="col-3 col-sm-2 alignNameDesig">
                                <img
                                  className="rounded-circle img-fluid testimonial-image"
                                  src={testimonial.img_url}
                                ></img>
                              </div>
                              <div className="text-left alignNameDesig col-9 col-sm-10 pl-0 testimonial-handle-plus-achivement-container">
                                <div
                                  className="h5 sofia-pro mb-1"
                                  dangerouslySetInnerHTML={{
                                    __html: testimonial.handle,
                                  }}
                                ></div>
                                <div
                                  style={{ lineHeight: "22px" }}
                                  className="text-success sofia-pro testimonial-achivement"
                                  dangerouslySetInnerHTML={{
                                    __html: testimonial.achievements,
                                  }}
                                ></div>
                              </div>
                            </div>
                            <div className="card-body pt-3">
                              {/* <div className="card-text text-left text-muted urw-din testimonial-content" dangerouslySetInnerHTML={{ __html: testimonial.modified_data }}></div> */}
                              <span
                                className="read-more-testimonial"
                                style={{
                                  float: "right",
                                  fontSize: "12px",
                                  color: "#28a745",
                                }}
                              >
                                Read Success Stories
                                <Icon name="angle double right" />
                              </span>
                            </div>
                          </div>
                        )
                      )}
                    </Carousel>
                  </div>
                )}
              </div>

              <div className="col-12">
                {this.state.courseLocations?.length > 0 &&
                  this.state.courseCardData.courseType === 0 && (
                    <section className="course-locations">
                      <CourseLocations
                        locations={this.state.courseLocations}
                        handleLocation={this.handleLocation}
                      />
                    </section>
                  )}
                <OverviewComponent
                  data={this.state.courseOverviewData}
                ></OverviewComponent>

                {/* Requirements :- Show Course Feature Component only if it is present else show What You Will Learn */}
                {this.state.courseFeaturesList &&
                this.state.courseFeaturesList.length ? (
                  <WhatGFGHaveToOffer data={this.state}></WhatGFGHaveToOffer>
                ) : (
                  <WhatYouLearnComponent
                    data={this.state.learningsData}
                  ></WhatYouLearnComponent>
                )}

                {/* <BenefitsComponent data = {this.state.otherBenefits}></BenefitsComponent> */}
                <CourseContentComponent
                  isLoggedIn={this.state.is_logged_in}
                  data={this.state.courseContentData}
                  courseSlug={this.props.match.params.course_slug}
                ></CourseContentComponent>
                {this.state.isLoaded && (
                  <ReviewsComponent
                    courseSlug={this.props.match.params.course_slug}
                    setTestimonials={(testimonials) => {
                      this.setState({
                        testimonials,
                      });
                    }}
                    showtestimonialModal={this.showtestimonialModal}
                    showTestimonialModalContent={
                      this.state.showTestimonialModalContent
                    }
                  ></ReviewsComponent>
                )}
              </div>
              <div className="col-12 pl-0 pr-0">
                <InstructorComponent
                  data={this.state.instructorData}
                  playVideo={this.playVideo}
                  demoVideo={this.state.demoVideo}
                  showMentorRating={this.state.showMentorRating}
                ></InstructorComponent>
              </div>
              <div id="batchSection-parent" className="col-md-12 batchSection">
                {this.mapLiveOrOnlineCourseSection()}
              </div>
              {this.state.faq && (
                <div className="col-md-12 pl-0 pr-0">
                  <FrequentlyAskedQuestionsComponent data={this.state.faq} />
                </div>
              )}
            </div>
            {this.state.showCapture && <ChatAnalyticsComponent />}
          </section>
        </React.Fragment>
      );
    }
  }
}

export default withRouter(LandingPage);
